import styled from "styled-components";
import {Space, Select} from "antd";

export const SpaceField = styled(Space)`
    @media (max-width: 768px;) {
        display: flex;
        flex-direction: column;
    }
`;

export const SelectTitle = styled.h6`
    font-weight: bold;
    color: #1890FF;
`;

export const CustomSelect = styled(Select)`
    .ant-select-selector {
        background-color: ${props => (props.disabled ? "#f5f5f5" : "white")} !important;
    }
    .ant-select-selection-item {
        color: ${props => (props.disabled ? "#545454" : "black")} !important;
    }
`;

export const SlotCourierTitle = styled.span`
    color: #000000;
    margin-left: 1vh;
    font-weight: 300;
    font-size: 15px;
    color: red;
`;
